<app-header [selectedMenu]="selectedMenu"></app-header>

<div class="container" (scroll)="onScrollTop($event)">

  <!-- div class="wrapper" #main
       (click)="onFocusMain($event)" -->
  <div class="wrapper">

    <aside class="rope"
           (click)="onClickRope($event)">
      <div class="up-arrow"></div>
    </aside>
    <app-back-btn></app-back-btn>

    <section class="search-result">

      <div #extContainer
           class="inner wrap flex-column">

        <app-search-box #extHeader
                        [keyword]="keyword"
                        [placeholder]="placeholder"
                        [keyHistoryKeyword]="historyKeySearch"
                        [keyHistoryView]="historyKeyView"
                        [top]="scrollTop"
                        (search)="onSearch($event)"
                        (goHistory)="onGoHistory()"></app-search-box>

        <div class="search-body-box">


          <article class="book-layout">

            <div #extBody2
                 class="book-layout-wrap">

              <div class="book-page-list">

                <app-jaso-index [curJasoIdx]="curJasoIdx"
                                [second]="jasoIdxSecond"
                                (search)="onSearch($event)"></app-jaso-index>

                <div #extBody
                     class="book-page-group">

                  <div class="page-box {{ isNoResult() ? 'empty' : ''}}">
                    <div #container
                         (scroll)="onScroll($event)"
                         class="page-contents scroll-effect over-y">

                      <article class="result-list-layout1"
                               [class.empty]="isNoResult()">
                        <div class="list-wrap" #innerScroll>
                          <ul>
                            <!-- app-word-list-help *ngIf="ll?.getTotalCount() ?? 0 > 0"
                                                (article)="curDetail = $event"></app-word-list-help -->

                            <li *ngFor="let word of ll?.getList(); let idx = index">
                              <app-word-list-item [word]="word"
                                                  [showLevel]="showLevel"
                                                  (viewInit)="onChildViewInit($event)"
                                                  (click)="onSelectWord(word.id, $event)">

                              </app-word-list-item>
                            </li>

                            <li class="reload-icon" *ngIf="ll && !ll.IsComplete()">
                              <img #reload src="assets/img/loading_icon.gif">
                            </li>

                            <li class="no-result" *ngIf="isNoResult()">
                              <div class="no-result-img"></div>
                              <div class="no-result-txt">{{ noResultTxt }}</div>
                              <div class="no-result-txt level"
                                   *ngIf="!wordLevelAll">설정에서 '단어 난이도 표시'를 변경 하고 다시 시도해 보세요.</div>
                            </li>

                          </ul>
                        </div>
                      </article>

                    </div>

                  </div>
                  <div class="page-box {{ isNoResult() ? 'empty' : ''}}">

                    <!-- 도움말 -->
                    <app-word-help-btn></app-word-help-btn>

                    <app-word-detail #wordDetail
                                     *ngIf="curDetailWord"
                                     [word_id]="curDetailWord"
                                     [showLevel]="showLevel"
                                     (bookmarkChange)="onBookmarkChange($event)"
                                     [autoPlay]="autoPlay"></app-word-detail>

                    <div *ngIf="curDetailArticle"
                         class="page-contents">
                      <app-board-detail [article_no]="curDetailArticle.no"></app-board-detail>
                    </div>
                  </div>

                  <div *ngIf="showScrollDown"
                       class="scroll-down"
                       (mousedown)="onStartScrollDown($event)"
                       (mouseup)="onEndScrollDown($event)"
                       (mouseleave)="onEndScrollDown($event)"
                       (touchstart)="onStartScrollDown($event)"
                       (touchend)="onEndScrollDown($event)"
                       (touchcancel)="onEndScrollDown($event)">
                  </div>
                </div>


              </div>

            </div>



          </article>

        </div>

      </div>

    </section>

  </div>


  <!-- app-footer></app-footer -->

  <app-common-popups></app-common-popups>

</div>
